function read(key: keyof ImportMetaEnv): string {
  return import.meta.env[key] ?? "";
}

/** 构建期环境变量（见 .env.example） */
export const env = {
  appEnv: read("VITE_APP_ENV") || (import.meta.env.DEV ? "local" : "production"),
  apiBaseUrl: read("VITE_API_BASE_URL") || "/api/v1",
} as const;
